<template>
  <!-- bootstrap-vue-next 0.45 : <BApp> fournit le contexte orchestrator + registries (modales/toasts) et monte
       l'orchestrator unique. -->
  <BApp id="app">
    <ribbon></ribbon>
    <div id="app-header">
      <jhi-navbar></jhi-navbar>
    </div>
    <div class="container-fluid">
      <div class="card jh-card">
        <router-view></router-view>
      </div>
      <b-modal v-model="loginShown" id="login-page" no-footer lazy>
        <template #title>
          <span data-cy="loginTitle" id="login-title">{{ $t('login.title') }}</span>
        </template>
        <login-form></login-form>
      </b-modal>

      <jhi-footer></jhi-footer>
    </div>
  </BApp>
</template>

<script lang="ts" src="./app.component.ts"></script>
